import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MaterialModule } from '../material/material.module';
import { FooterComponent } from './footer/footer.component';
import { NavigationComponent } from './navigation.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { DialogModule } from '../custom-components/dialog/dialog.module';
import { CustomHeaderModule } from '../custom-components/custom-header/custom-header.module';
import { LoaderModule } from '../custom-components/loader/loader.module';
import {MatBadgeModule} from '@angular/material/badge';
import {ScrollingModule} from '@angular/cdk/scrolling';


@NgModule({
  declarations: [
    NavigationComponent,
    ToolbarComponent,
    FooterComponent,
    SidenavComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    DialogModule,
    MatIconModule,
    CustomHeaderModule,
    LoaderModule,
    MatBadgeModule,
    ScrollingModule
    
  ],
    exports: [
        NavigationComponent,
        SidenavComponent,
    ]
})
export class NavigationModule { }
